/**
 * Contactpage
 * Contact section: info cards, an embedded Google Map of Cole Harbour, NS, and
 * the contact form. Phone remains a placeholder until a public number is confirmed.
 */
import React from 'react';
import { MASJID } from '../../config/masjid';
import ContactForm from '../ContactFrom';
import './style.css';

const Contactpage = () => {
  const { fridayPrayer } = MASJID;

  return (
    <section className="wpo-contact-form-map section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="row">
              <div className="col col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="contact-form">
                  <h2>Get In Touch</h2>
                  <ContactForm />
                </div>
              </div>
              <div className="col col-lg-6 col-md-6 col-sm-12 col-12">
                <div className="contact-map">
                  <iframe
                    title="Cole Harbour Masjid location map"
                    loading="lazy"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    src={fridayPrayer.mapEmbedUrl}
                  ></iframe>
                </div>
              </div>
            </div>
            <div className="wpo-contact-info">
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="info-item">
                    <h2>{fridayPrayer.address}</h2>
                    <div className="info-wrap">
                      <div className="info-icon">
                        <i className="ti-world"></i>
                      </div>
                      <div className="info-text">
                        <span>Office Address</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="info-item">
                    <h2>
                      <a href={`mailto:${MASJID.contactEmail}`}>
                        {MASJID.contactEmail}
                      </a>
                    </h2>
                    <div className="info-wrap">
                      <div className="info-icon-2">
                        <i className="fi flaticon-envelope"></i>
                      </div>
                      <div className="info-text">
                        <span>Official Mail</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 col-12">
                  <div className="info-item">
                    {/* TODO: Replace with the real public masjid phone number when available. */}
                    <h2>Phone number coming soon</h2>
                    <div className="info-wrap">
                      <div className="info-icon-3">
                        <i className="ti-headphone-alt"></i>
                      </div>
                      <div className="info-text">
                        <span>Official Phone</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contactpage;
